<template>
	<div
		class="w-full bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden"
	>
		<div class="bg-primary px-6 py-4">
			<div class="flex items-center justify-between">
				<div>
					<h4 class="text-base font-bold text-white">
						Recent Activity
					</h4>
					<p class="text-xs text-brand-cyan mt-0.5">
						Latest updates from your account
					</p>
				</div>
				<button
					type="button"
					class="text-xs font-medium text-brand-cyan hover:text-white transition-colors duration-200 focus:outline-none"
				>
					View All
				</button>
			</div>
		</div>

		<div class="p-6">
			<ul class="space-y-4">
				<li
					v-for="(act, idx) in activities"
					:key="idx"
					class="group relative"
					:aria-label="`Activity: ${act.title}`"
				>
					<div
						class="flex items-start gap-4 p-4 rounded-lg bg-surface hover:bg-white hover:shadow-lg border border-transparent hover:border-gray-100 transition-all duration-300 cursor-pointer"
					>
						<div
							:class="[
								'w-12 h-12 rounded-lg flex items-center justify-center shrink-0 shadow-sm',
								act.iconBg,
							]"
						>
							<i
								:class="act.iconClass + ' text-white text-lg'"
								aria-hidden="true"
							></i>
						</div>

						<div class="flex-1 min-w-0">
							<div
								class="flex items-start justify-between gap-3 mb-1"
							>
								<h5
									class="text-sm font-semibold text-text-primary group-hover:text-primary transition-colors duration-200"
								>
									{{ act.title }}
								</h5>
								<span
									class="text-xs font-medium text-text-secondary shrink-0 bg-gray-100 px-2 py-1 rounded"
								>
									{{ act.timeAgo }}
								</span>
							</div>
							<p
								class="text-xs text-text-secondary leading-relaxed"
							>
								{{ act.description }}
							</p>
						</div>

						<div
							v-if="act.status"
							:class="[
								'absolute top-4 right-4 w-2 h-2 rounded-full',
								act.status === 'new'
									? 'bg-accent'
									: 'bg-green-500',
							]"
						></div>
					</div>
				</li>
			</ul>

			<div v-if="activities.length === 0" class="text-center py-12">
				<div
					class="w-16 h-16 bg-surface rounded-full flex items-center justify-center mx-auto mb-3"
				>
					<i class="fas fa-history text-text-secondary text-2xl"></i>
				</div>
				<p class="text-sm font-medium text-text-primary">
					No recent activity
				</p>
				<p class="text-xs text-text-secondary mt-1">
					Your activity will appear here
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RecentActivity',
	data() {
		return {
			activities: [
				{
					title: 'Policy Renewal Completed',
					description:
						'Your auto insurance policy was renewed successfully and is now active for the next 12 months.',
					timeAgo: '2h ago',
					iconClass: 'fas fa-check-circle',
					iconBg: 'bg-green-500',
					status: 'completed',
				},
				{
					title: 'New Quotation Available',
					description:
						'You have received a new quotation for comprehensive health insurance coverage.',
					timeAgo: '1d ago',
					iconClass: 'fas fa-file-invoice-dollar',
					iconBg: 'bg-brand-cyan',
					status: 'new',
				},
				{
					title: 'Payment Processed',
					description:
						'Your premium payment of KES 15,000 has been successfully processed.',
					timeAgo: '3d ago',
					iconClass: 'fas fa-credit-card',
					iconBg: 'bg-primary',
					status: 'completed',
				},
				{
					title: 'Document Upload Required',
					description:
						'Please upload the required documents to complete your claim application.',
					timeAgo: '5d ago',
					iconClass: 'fas fa-exclamation-triangle',
					iconBg: 'bg-accent',
					status: 'new',
				},
			],
		};
	},
};
</script>

<style scoped>
button:focus {
	outline: 2px solid theme('colors.brand.cyan');
	outline-offset: 2px;
}

.group:hover i {
	transform: scale(1.1);
	transition: transform 0.2s ease;
}
</style>
